import { /*defineStyle, defineStyleConfig,*/ defineStyleConfig, extendTheme } from "@chakra-ui/react";
import { ChakraTheme } from "@chakra-ui/react";
import { theme as coreTheme } from "am-tax-fe-core";

const Text = defineStyleConfig({
    variants: {
        sectionHeader: {
            fontSize:{base: "1.25rem", sm: "1.5rem", md:"1.75rem"},
            fontWeight: "bold"
        },
    },
    // The default variant value
    defaultProps: {},
})
const themeOverrides: Partial<ChakraTheme> = {
    components: {
        Text
    },
};
export const theme = extendTheme(coreTheme, themeOverrides);
